import { render, staticRenderFns } from "./Kayak.vue?vue&type=template&id=fc325c94&"
import script from "./Kayak.vue?vue&type=script&lang=js&"
export * from "./Kayak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports